/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * Сервис Интранет — API
 * API внутреннего корпоративного портала
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  AddCoExecutorDto,
  AddLinkDto,
  AssignmentCountsDto,
  AssignmentDetailDto,
  AssignmentFileUrlDto,
  AssignmentIdDto,
  AssignmentListItemDto,
  AssignmentPersonDto,
  AssignmentSummaryDto,
  AssignmentsControllerAddFileV1Body,
  AssignmentsControllerCountsV1Params,
  AssignmentsControllerExportListV1Params,
  AssignmentsControllerExportRegistryV1Params,
  AssignmentsControllerFileUrlV1Params,
  AssignmentsControllerListV1Params,
  AssignmentsControllerPartialReportV1Body,
  AssignmentsControllerReportV1Body,
  CancelAssignmentDto,
  ChangeDeadlineDto,
  CreateAssignmentDto,
  CreateCommentDto,
  DecideExtensionDto,
  DelegateAssignmentDto,
  RequestExtensionDto,
  ReturnReportDto,
  UpdateAssignmentDto
} from '../models';

import { apiRequest } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type assignmentsControllerListV1Response200 = {
  data: AssignmentListItemDto[]
  status: 200
}

export type assignmentsControllerListV1ResponseSuccess = (assignmentsControllerListV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerListV1Response = (assignmentsControllerListV1ResponseSuccess)

export const getAssignmentsControllerListV1Url = (params: AssignmentsControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assignments?${stringifiedParams}` : `/api/v1/assignments`
}

/**
 * @summary Мои поручения (view=mine&tab=…) или реестр контроля (view=registry&scope=…)
 */
export const assignmentsControllerListV1 = async (params: AssignmentsControllerListV1Params, options?: RequestInit): Promise<assignmentsControllerListV1Response> => {

  return apiRequest<assignmentsControllerListV1Response>(getAssignmentsControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerListV1>>, TError,{params: AssignmentsControllerListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerListV1>>, TError,{params: AssignmentsControllerListV1Params}, TContext> => {

const mutationKey = ['assignmentsControllerListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerListV1>>, {params: AssignmentsControllerListV1Params}> = (props) => {
          const {params} = props ?? {};

          return  assignmentsControllerListV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerListV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerListV1>>>

    export type AssignmentsControllerListV1MutationError = unknown

    /**
 * @summary Мои поручения (view=mine&tab=…) или реестр контроля (view=registry&scope=…)
 */
export const useAssignmentsControllerListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerListV1>>, TError,{params: AssignmentsControllerListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerListV1>>,
        TError,
        {params: AssignmentsControllerListV1Params},
        TContext
      > => {
      return useMutation(getAssignmentsControllerListV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerCreateV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerCreateV1ResponseSuccess = (assignmentsControllerCreateV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerCreateV1Response = (assignmentsControllerCreateV1ResponseSuccess)

export const getAssignmentsControllerCreateV1Url = () => {




  return `/api/v1/assignments`
}

/**
 * @summary Создать черновик (автор — текущий сотрудник)
 */
export const assignmentsControllerCreateV1 = async (createAssignmentDto: CreateAssignmentDto, options?: RequestInit): Promise<assignmentsControllerCreateV1Response> => {

  return apiRequest<assignmentsControllerCreateV1Response>(getAssignmentsControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAssignmentDto)
  }
);}





export const getAssignmentsControllerCreateV1QueryKey = (createAssignmentDto?: MaybeRef<CreateAssignmentDto>,) => {
    return [
    'POST', 'api','v1','assignments', createAssignmentDto
    ] as const;
    }


export const getAssignmentsControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerCreateV1>>, TError = unknown>(createAssignmentDto: MaybeRef<CreateAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerCreateV1QueryKey(createAssignmentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerCreateV1>>> = ({ signal }) => assignmentsControllerCreateV1(unref(createAssignmentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCreateV1>>, TError, TData>
}

export type AssignmentsControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerCreateV1>>>
export type AssignmentsControllerCreateV1QueryError = unknown


/**
 * @summary Создать черновик (автор — текущий сотрудник)
 */

export function useAssignmentsControllerCreateV1<TData = Awaited<ReturnType<typeof assignmentsControllerCreateV1>>, TError = unknown>(
 createAssignmentDto: MaybeRef<CreateAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerCreateV1QueryOptions(createAssignmentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerExportListV1Response200 = {
  data: void
  status: 200
}

export type assignmentsControllerExportListV1ResponseSuccess = (assignmentsControllerExportListV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerExportListV1Response = (assignmentsControllerExportListV1ResponseSuccess)

export const getAssignmentsControllerExportListV1Url = (params: AssignmentsControllerExportListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assignments/export.xlsx?${stringifiedParams}` : `/api/v1/assignments/export.xlsx`
}

/**
 * @summary Поручения в Excel — «Мои поручения» (view=mine&tab=…) или реестр (view=registry&scope=…), как на экране
 */
export const assignmentsControllerExportListV1 = async (params: AssignmentsControllerExportListV1Params, options?: RequestInit): Promise<assignmentsControllerExportListV1Response> => {

  return apiRequest<assignmentsControllerExportListV1Response>(getAssignmentsControllerExportListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerExportListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerExportListV1>>, TError,{params: AssignmentsControllerExportListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerExportListV1>>, TError,{params: AssignmentsControllerExportListV1Params}, TContext> => {

const mutationKey = ['assignmentsControllerExportListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerExportListV1>>, {params: AssignmentsControllerExportListV1Params}> = (props) => {
          const {params} = props ?? {};

          return  assignmentsControllerExportListV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerExportListV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerExportListV1>>>

    export type AssignmentsControllerExportListV1MutationError = unknown

    /**
 * @summary Поручения в Excel — «Мои поручения» (view=mine&tab=…) или реестр (view=registry&scope=…), как на экране
 */
export const useAssignmentsControllerExportListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerExportListV1>>, TError,{params: AssignmentsControllerExportListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerExportListV1>>,
        TError,
        {params: AssignmentsControllerExportListV1Params},
        TContext
      > => {
      return useMutation(getAssignmentsControllerExportListV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerExportRegistryV1Response200 = {
  data: void
  status: 200
}

export type assignmentsControllerExportRegistryV1ResponseSuccess = (assignmentsControllerExportRegistryV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerExportRegistryV1Response = (assignmentsControllerExportRegistryV1ResponseSuccess)

export const getAssignmentsControllerExportRegistryV1Url = (params: AssignmentsControllerExportRegistryV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assignments/registry/export.xlsx?${stringifiedParams}` : `/api/v1/assignments/registry/export.xlsx`
}

/**
 * @summary Реестр контроля в Excel — текущая выборка с фильтрами
 */
export const assignmentsControllerExportRegistryV1 = async (params: AssignmentsControllerExportRegistryV1Params, options?: RequestInit): Promise<assignmentsControllerExportRegistryV1Response> => {

  return apiRequest<assignmentsControllerExportRegistryV1Response>(getAssignmentsControllerExportRegistryV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerExportRegistryV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerExportRegistryV1>>, TError,{params: AssignmentsControllerExportRegistryV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerExportRegistryV1>>, TError,{params: AssignmentsControllerExportRegistryV1Params}, TContext> => {

const mutationKey = ['assignmentsControllerExportRegistryV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerExportRegistryV1>>, {params: AssignmentsControllerExportRegistryV1Params}> = (props) => {
          const {params} = props ?? {};

          return  assignmentsControllerExportRegistryV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerExportRegistryV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerExportRegistryV1>>>

    export type AssignmentsControllerExportRegistryV1MutationError = unknown

    /**
 * @summary Реестр контроля в Excel — текущая выборка с фильтрами
 */
export const useAssignmentsControllerExportRegistryV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerExportRegistryV1>>, TError,{params: AssignmentsControllerExportRegistryV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerExportRegistryV1>>,
        TError,
        {params: AssignmentsControllerExportRegistryV1Params},
        TContext
      > => {
      return useMutation(getAssignmentsControllerExportRegistryV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerCountsV1Response200 = {
  data: AssignmentCountsDto
  status: 200
}

export type assignmentsControllerCountsV1ResponseSuccess = (assignmentsControllerCountsV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerCountsV1Response = (assignmentsControllerCountsV1ResponseSuccess)

export const getAssignmentsControllerCountsV1Url = (params: AssignmentsControllerCountsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assignments/counts?${stringifiedParams}` : `/api/v1/assignments/counts`
}

/**
 * @summary Сколько действующих и в архиве — для переключателя (view=registry&scope=… или view=project&projectId=…)
 */
export const assignmentsControllerCountsV1 = async (params: AssignmentsControllerCountsV1Params, options?: RequestInit): Promise<assignmentsControllerCountsV1Response> => {

  return apiRequest<assignmentsControllerCountsV1Response>(getAssignmentsControllerCountsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerCountsV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerCountsV1>>, TError,{params: AssignmentsControllerCountsV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerCountsV1>>, TError,{params: AssignmentsControllerCountsV1Params}, TContext> => {

const mutationKey = ['assignmentsControllerCountsV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerCountsV1>>, {params: AssignmentsControllerCountsV1Params}> = (props) => {
          const {params} = props ?? {};

          return  assignmentsControllerCountsV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerCountsV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerCountsV1>>>

    export type AssignmentsControllerCountsV1MutationError = unknown

    /**
 * @summary Сколько действующих и в архиве — для переключателя (view=registry&scope=… или view=project&projectId=…)
 */
export const useAssignmentsControllerCountsV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerCountsV1>>, TError,{params: AssignmentsControllerCountsV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerCountsV1>>,
        TError,
        {params: AssignmentsControllerCountsV1Params},
        TContext
      > => {
      return useMutation(getAssignmentsControllerCountsV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerByNumberV1Response200 = {
  data: AssignmentIdDto
  status: 200
}

export type assignmentsControllerByNumberV1ResponseSuccess = (assignmentsControllerByNumberV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerByNumberV1Response = (assignmentsControllerByNumberV1ResponseSuccess)

export const getAssignmentsControllerByNumberV1Url = (number: number,) => {




  return `/api/v1/assignments/by-number/${number}`
}

/**
 * @summary Поручение по номеру (ссылки «№ 24» в тексте) — только среди видимых
 */
export const assignmentsControllerByNumberV1 = async (number: number, options?: RequestInit): Promise<assignmentsControllerByNumberV1Response> => {

  return apiRequest<assignmentsControllerByNumberV1Response>(getAssignmentsControllerByNumberV1Url(number),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerByNumberV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerByNumberV1>>, TError,{number: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerByNumberV1>>, TError,{number: number}, TContext> => {

const mutationKey = ['assignmentsControllerByNumberV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerByNumberV1>>, {number: number}> = (props) => {
          const {number} = props ?? {};

          return  assignmentsControllerByNumberV1(number,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerByNumberV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerByNumberV1>>>

    export type AssignmentsControllerByNumberV1MutationError = unknown

    /**
 * @summary Поручение по номеру (ссылки «№ 24» в тексте) — только среди видимых
 */
export const useAssignmentsControllerByNumberV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerByNumberV1>>, TError,{number: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerByNumberV1>>,
        TError,
        {number: number},
        TContext
      > => {
      return useMutation(getAssignmentsControllerByNumberV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerSummaryV1Response200 = {
  data: AssignmentSummaryDto
  status: 200
}

export type assignmentsControllerSummaryV1ResponseSuccess = (assignmentsControllerSummaryV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerSummaryV1Response = (assignmentsControllerSummaryV1ResponseSuccess)

export const getAssignmentsControllerSummaryV1Url = () => {




  return `/api/v1/assignments/summary`
}

/**
 * @summary Счётчики вкладок и доступные охваты реестра
 */
export const assignmentsControllerSummaryV1 = async ( options?: RequestInit): Promise<assignmentsControllerSummaryV1Response> => {

  return apiRequest<assignmentsControllerSummaryV1Response>(getAssignmentsControllerSummaryV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerSummaryV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerSummaryV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerSummaryV1>>, TError,void, TContext> => {

const mutationKey = ['assignmentsControllerSummaryV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerSummaryV1>>, void> = () => {


          return  assignmentsControllerSummaryV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerSummaryV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerSummaryV1>>>

    export type AssignmentsControllerSummaryV1MutationError = unknown

    /**
 * @summary Счётчики вкладок и доступные охваты реестра
 */
export const useAssignmentsControllerSummaryV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerSummaryV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerSummaryV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAssignmentsControllerSummaryV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerGetByIdV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerGetByIdV1ResponseSuccess = (assignmentsControllerGetByIdV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerGetByIdV1Response = (assignmentsControllerGetByIdV1ResponseSuccess)

export const getAssignmentsControllerGetByIdV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}`
}

/**
 * @summary Карточка поручения с доступными действиями
 */
export const assignmentsControllerGetByIdV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerGetByIdV1Response> => {

  return apiRequest<assignmentsControllerGetByIdV1Response>(getAssignmentsControllerGetByIdV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerGetByIdV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerGetByIdV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerGetByIdV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['assignmentsControllerGetByIdV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerGetByIdV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  assignmentsControllerGetByIdV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerGetByIdV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerGetByIdV1>>>

    export type AssignmentsControllerGetByIdV1MutationError = unknown

    /**
 * @summary Карточка поручения с доступными действиями
 */
export const useAssignmentsControllerGetByIdV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerGetByIdV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerGetByIdV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAssignmentsControllerGetByIdV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerUpdateV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerUpdateV1ResponseSuccess = (assignmentsControllerUpdateV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerUpdateV1Response = (assignmentsControllerUpdateV1ResponseSuccess)

export const getAssignmentsControllerUpdateV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}`
}

/**
 * @summary Изменить поручение (правка пишется в историю)
 */
export const assignmentsControllerUpdateV1 = async (id: string,
    updateAssignmentDto: UpdateAssignmentDto, options?: RequestInit): Promise<assignmentsControllerUpdateV1Response> => {

  return apiRequest<assignmentsControllerUpdateV1Response>(getAssignmentsControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAssignmentDto)
  }
);}





export const getAssignmentsControllerUpdateV1QueryKey = (id: MaybeRef<string>,
    updateAssignmentDto?: MaybeRef<UpdateAssignmentDto>,) => {
    return [
    'PATCH', 'api','v1','assignments',id, updateAssignmentDto
    ] as const;
    }


export const getAssignmentsControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>, TError = unknown>(id: MaybeRef<string>,
    updateAssignmentDto: MaybeRef<UpdateAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerUpdateV1QueryKey(id,updateAssignmentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>> = ({ signal }) => assignmentsControllerUpdateV1(unref(id),unref(updateAssignmentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>, TError, TData>
}

export type AssignmentsControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>>
export type AssignmentsControllerUpdateV1QueryError = unknown


/**
 * @summary Изменить поручение (правка пишется в историю)
 */

export function useAssignmentsControllerUpdateV1<TData = Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>, TError = unknown>(
 id: MaybeRef<string>,
    updateAssignmentDto: MaybeRef<UpdateAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerUpdateV1QueryOptions(id,updateAssignmentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerRemoveV1Response204 = {
  data: void
  status: 204
}

export type assignmentsControllerRemoveV1ResponseSuccess = (assignmentsControllerRemoveV1Response204) & {
  headers: Headers;
};
;

export type assignmentsControllerRemoveV1Response = (assignmentsControllerRemoveV1ResponseSuccess)

export const getAssignmentsControllerRemoveV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}`
}

/**
 * @summary Удалить черновик
 */
export const assignmentsControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerRemoveV1Response> => {

  return apiRequest<assignmentsControllerRemoveV1Response>(getAssignmentsControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAssignmentsControllerRemoveV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','assignments',id
    ] as const;
    }


export const getAssignmentsControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>> = ({ signal }) => assignmentsControllerRemoveV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>, TError, TData>
}

export type AssignmentsControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>>
export type AssignmentsControllerRemoveV1QueryError = unknown


/**
 * @summary Удалить черновик
 */

export function useAssignmentsControllerRemoveV1<TData = Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerSendToApprovalV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerSendToApprovalV1ResponseSuccess = (assignmentsControllerSendToApprovalV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerSendToApprovalV1Response = (assignmentsControllerSendToApprovalV1ResponseSuccess)

export const getAssignmentsControllerSendToApprovalV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/send-to-approval`
}

/**
 * @summary Черновик → на утверждение наблюдателю
 */
export const assignmentsControllerSendToApprovalV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerSendToApprovalV1Response> => {

  return apiRequest<assignmentsControllerSendToApprovalV1Response>(getAssignmentsControllerSendToApprovalV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAssignmentsControllerSendToApprovalV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'POST', 'api','v1','assignments',id,'send-to-approval'
    ] as const;
    }


export const getAssignmentsControllerSendToApprovalV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerSendToApprovalV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>> = ({ signal }) => assignmentsControllerSendToApprovalV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>, TError, TData>
}

export type AssignmentsControllerSendToApprovalV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>>
export type AssignmentsControllerSendToApprovalV1QueryError = unknown


/**
 * @summary Черновик → на утверждение наблюдателю
 */

export function useAssignmentsControllerSendToApprovalV1<TData = Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerSendToApprovalV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerSendToApprovalV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerSendV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerSendV1ResponseSuccess = (assignmentsControllerSendV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerSendV1Response = (assignmentsControllerSendV1ResponseSuccess)

export const getAssignmentsControllerSendV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/send`
}

/**
 * @summary Черновик → исполнителю
 */
export const assignmentsControllerSendV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerSendV1Response> => {

  return apiRequest<assignmentsControllerSendV1Response>(getAssignmentsControllerSendV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAssignmentsControllerSendV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'POST', 'api','v1','assignments',id,'send'
    ] as const;
    }


export const getAssignmentsControllerSendV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerSendV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerSendV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerSendV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerSendV1>>> = ({ signal }) => assignmentsControllerSendV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerSendV1>>, TError, TData>
}

export type AssignmentsControllerSendV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerSendV1>>>
export type AssignmentsControllerSendV1QueryError = unknown


/**
 * @summary Черновик → исполнителю
 */

export function useAssignmentsControllerSendV1<TData = Awaited<ReturnType<typeof assignmentsControllerSendV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerSendV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerSendV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerApproveV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerApproveV1ResponseSuccess = (assignmentsControllerApproveV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerApproveV1Response = (assignmentsControllerApproveV1ResponseSuccess)

export const getAssignmentsControllerApproveV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/approve`
}

/**
 * @summary Наблюдатель утверждает → «Новое»
 */
export const assignmentsControllerApproveV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerApproveV1Response> => {

  return apiRequest<assignmentsControllerApproveV1Response>(getAssignmentsControllerApproveV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAssignmentsControllerApproveV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'POST', 'api','v1','assignments',id,'approve'
    ] as const;
    }


export const getAssignmentsControllerApproveV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerApproveV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerApproveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerApproveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerApproveV1>>> = ({ signal }) => assignmentsControllerApproveV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerApproveV1>>, TError, TData>
}

export type AssignmentsControllerApproveV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerApproveV1>>>
export type AssignmentsControllerApproveV1QueryError = unknown


/**
 * @summary Наблюдатель утверждает → «Новое»
 */

export function useAssignmentsControllerApproveV1<TData = Awaited<ReturnType<typeof assignmentsControllerApproveV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerApproveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerApproveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerReturnToAuthorV1Response204 = {
  data: void
  status: 204
}

export type assignmentsControllerReturnToAuthorV1ResponseSuccess = (assignmentsControllerReturnToAuthorV1Response204) & {
  headers: Headers;
};
;

export type assignmentsControllerReturnToAuthorV1Response = (assignmentsControllerReturnToAuthorV1ResponseSuccess)

export const getAssignmentsControllerReturnToAuthorV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/return-to-author`
}

/**
 * @summary Наблюдатель возвращает поручение автору в черновик (комментарий обязателен); карточка ему больше не видна
 */
export const assignmentsControllerReturnToAuthorV1 = async (id: string,
    returnReportDto: ReturnReportDto, options?: RequestInit): Promise<assignmentsControllerReturnToAuthorV1Response> => {

  return apiRequest<assignmentsControllerReturnToAuthorV1Response>(getAssignmentsControllerReturnToAuthorV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnReportDto)
  }
);}





export const getAssignmentsControllerReturnToAuthorV1QueryKey = (id: MaybeRef<string>,
    returnReportDto?: MaybeRef<ReturnReportDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'return-to-author', returnReportDto
    ] as const;
    }


export const getAssignmentsControllerReturnToAuthorV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>, TError = unknown>(id: MaybeRef<string>,
    returnReportDto: MaybeRef<ReturnReportDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerReturnToAuthorV1QueryKey(id,returnReportDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>> = ({ signal }) => assignmentsControllerReturnToAuthorV1(unref(id),unref(returnReportDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>, TError, TData>
}

export type AssignmentsControllerReturnToAuthorV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>>
export type AssignmentsControllerReturnToAuthorV1QueryError = unknown


/**
 * @summary Наблюдатель возвращает поручение автору в черновик (комментарий обязателен); карточка ему больше не видна
 */

export function useAssignmentsControllerReturnToAuthorV1<TData = Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>, TError = unknown>(
 id: MaybeRef<string>,
    returnReportDto: MaybeRef<ReturnReportDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReturnToAuthorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerReturnToAuthorV1QueryOptions(id,returnReportDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerOpenV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerOpenV1ResponseSuccess = (assignmentsControllerOpenV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerOpenV1Response = (assignmentsControllerOpenV1ResponseSuccess)

export const getAssignmentsControllerOpenV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/open`
}

/**
 * @summary Исполнитель открыл карточку: «Новое» → «В работе»
 */
export const assignmentsControllerOpenV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerOpenV1Response> => {

  return apiRequest<assignmentsControllerOpenV1Response>(getAssignmentsControllerOpenV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAssignmentsControllerOpenV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'POST', 'api','v1','assignments',id,'open'
    ] as const;
    }


export const getAssignmentsControllerOpenV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerOpenV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerOpenV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerOpenV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerOpenV1>>> = ({ signal }) => assignmentsControllerOpenV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerOpenV1>>, TError, TData>
}

export type AssignmentsControllerOpenV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerOpenV1>>>
export type AssignmentsControllerOpenV1QueryError = unknown


/**
 * @summary Исполнитель открыл карточку: «Новое» → «В работе»
 */

export function useAssignmentsControllerOpenV1<TData = Awaited<ReturnType<typeof assignmentsControllerOpenV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerOpenV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerOpenV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerReportV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerReportV1ResponseSuccess = (assignmentsControllerReportV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerReportV1Response = (assignmentsControllerReportV1ResponseSuccess)

export const getAssignmentsControllerReportV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/report`
}

/**
 * @summary Исполнитель направляет итоговый отчёт: текст и/или файлы (до 10, по 50 МБ)
 */
export const assignmentsControllerReportV1 = async (id: string,
    assignmentsControllerReportV1Body: AssignmentsControllerReportV1Body, options?: RequestInit): Promise<assignmentsControllerReportV1Response> => {
    const formData = new FormData();
if(assignmentsControllerReportV1Body.text !== undefined) {
 formData.append(`text`, assignmentsControllerReportV1Body.text);
 }
if(assignmentsControllerReportV1Body.files !== undefined) {
 assignmentsControllerReportV1Body.files.forEach(value => formData.append(`files`, value));
 }

  return apiRequest<assignmentsControllerReportV1Response>(getAssignmentsControllerReportV1Url(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAssignmentsControllerReportV1QueryKey = (id: MaybeRef<string>,
    assignmentsControllerReportV1Body?: MaybeRef<AssignmentsControllerReportV1Body>,) => {
    return [
    'POST', 'api','v1','assignments',id,'report', assignmentsControllerReportV1Body
    ] as const;
    }


export const getAssignmentsControllerReportV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerReportV1>>, TError = unknown>(id: MaybeRef<string>,
    assignmentsControllerReportV1Body: MaybeRef<AssignmentsControllerReportV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReportV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerReportV1QueryKey(id,assignmentsControllerReportV1Body);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerReportV1>>> = ({ signal }) => assignmentsControllerReportV1(unref(id),unref(assignmentsControllerReportV1Body), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReportV1>>, TError, TData>
}

export type AssignmentsControllerReportV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerReportV1>>>
export type AssignmentsControllerReportV1QueryError = unknown


/**
 * @summary Исполнитель направляет итоговый отчёт: текст и/или файлы (до 10, по 50 МБ)
 */

export function useAssignmentsControllerReportV1<TData = Awaited<ReturnType<typeof assignmentsControllerReportV1>>, TError = unknown>(
 id: MaybeRef<string>,
    assignmentsControllerReportV1Body: MaybeRef<AssignmentsControllerReportV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReportV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerReportV1QueryOptions(id,assignmentsControllerReportV1Body,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerRequestExtensionV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerRequestExtensionV1ResponseSuccess = (assignmentsControllerRequestExtensionV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerRequestExtensionV1Response = (assignmentsControllerRequestExtensionV1ResponseSuccess)

export const getAssignmentsControllerRequestExtensionV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/deadline-requests`
}

/**
 * @summary Запросить продление срока (исполнитель, соисполнитель)
 */
export const assignmentsControllerRequestExtensionV1 = async (id: string,
    requestExtensionDto: RequestExtensionDto, options?: RequestInit): Promise<assignmentsControllerRequestExtensionV1Response> => {

  return apiRequest<assignmentsControllerRequestExtensionV1Response>(getAssignmentsControllerRequestExtensionV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestExtensionDto)
  }
);}





export const getAssignmentsControllerRequestExtensionV1QueryKey = (id: MaybeRef<string>,
    requestExtensionDto?: MaybeRef<RequestExtensionDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'deadline-requests', requestExtensionDto
    ] as const;
    }


export const getAssignmentsControllerRequestExtensionV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>, TError = unknown>(id: MaybeRef<string>,
    requestExtensionDto: MaybeRef<RequestExtensionDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerRequestExtensionV1QueryKey(id,requestExtensionDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>> = ({ signal }) => assignmentsControllerRequestExtensionV1(unref(id),unref(requestExtensionDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>, TError, TData>
}

export type AssignmentsControllerRequestExtensionV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>>
export type AssignmentsControllerRequestExtensionV1QueryError = unknown


/**
 * @summary Запросить продление срока (исполнитель, соисполнитель)
 */

export function useAssignmentsControllerRequestExtensionV1<TData = Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>, TError = unknown>(
 id: MaybeRef<string>,
    requestExtensionDto: MaybeRef<RequestExtensionDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRequestExtensionV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerRequestExtensionV1QueryOptions(id,requestExtensionDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerDecideExtensionV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerDecideExtensionV1ResponseSuccess = (assignmentsControllerDecideExtensionV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerDecideExtensionV1Response = (assignmentsControllerDecideExtensionV1ResponseSuccess)

export const getAssignmentsControllerDecideExtensionV1Url = (id: string,
    requestId: string,) => {




  return `/api/v1/assignments/${id}/deadline-requests/${requestId}/decide`
}

/**
 * @summary Решить по запросу продления (контролёр)
 */
export const assignmentsControllerDecideExtensionV1 = async (id: string,
    requestId: string,
    decideExtensionDto: DecideExtensionDto, options?: RequestInit): Promise<assignmentsControllerDecideExtensionV1Response> => {

  return apiRequest<assignmentsControllerDecideExtensionV1Response>(getAssignmentsControllerDecideExtensionV1Url(id,requestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(decideExtensionDto)
  }
);}





export const getAssignmentsControllerDecideExtensionV1QueryKey = (id: MaybeRef<string>,
    requestId: MaybeRef<string>,
    decideExtensionDto?: MaybeRef<DecideExtensionDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'deadline-requests',requestId,'decide', decideExtensionDto
    ] as const;
    }


export const getAssignmentsControllerDecideExtensionV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>, TError = unknown>(id: MaybeRef<string>,
    requestId: MaybeRef<string>,
    decideExtensionDto: MaybeRef<DecideExtensionDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerDecideExtensionV1QueryKey(id,requestId,decideExtensionDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>> = ({ signal }) => assignmentsControllerDecideExtensionV1(unref(id),unref(requestId),unref(decideExtensionDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(requestId) !== null && unref(requestId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>, TError, TData>
}

export type AssignmentsControllerDecideExtensionV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>>
export type AssignmentsControllerDecideExtensionV1QueryError = unknown


/**
 * @summary Решить по запросу продления (контролёр)
 */

export function useAssignmentsControllerDecideExtensionV1<TData = Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>, TError = unknown>(
 id: MaybeRef<string>,
    requestId: MaybeRef<string>,
    decideExtensionDto: MaybeRef<DecideExtensionDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDecideExtensionV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerDecideExtensionV1QueryOptions(id,requestId,decideExtensionDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerChangeDeadlineV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerChangeDeadlineV1ResponseSuccess = (assignmentsControllerChangeDeadlineV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerChangeDeadlineV1Response = (assignmentsControllerChangeDeadlineV1ResponseSuccess)

export const getAssignmentsControllerChangeDeadlineV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/deadline`
}

/**
 * @summary Перенести срок без запроса (контролёр)
 */
export const assignmentsControllerChangeDeadlineV1 = async (id: string,
    changeDeadlineDto: ChangeDeadlineDto, options?: RequestInit): Promise<assignmentsControllerChangeDeadlineV1Response> => {

  return apiRequest<assignmentsControllerChangeDeadlineV1Response>(getAssignmentsControllerChangeDeadlineV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeDeadlineDto)
  }
);}





export const getAssignmentsControllerChangeDeadlineV1QueryKey = (id: MaybeRef<string>,
    changeDeadlineDto?: MaybeRef<ChangeDeadlineDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'deadline', changeDeadlineDto
    ] as const;
    }


export const getAssignmentsControllerChangeDeadlineV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>, TError = unknown>(id: MaybeRef<string>,
    changeDeadlineDto: MaybeRef<ChangeDeadlineDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerChangeDeadlineV1QueryKey(id,changeDeadlineDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>> = ({ signal }) => assignmentsControllerChangeDeadlineV1(unref(id),unref(changeDeadlineDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>, TError, TData>
}

export type AssignmentsControllerChangeDeadlineV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>>
export type AssignmentsControllerChangeDeadlineV1QueryError = unknown


/**
 * @summary Перенести срок без запроса (контролёр)
 */

export function useAssignmentsControllerChangeDeadlineV1<TData = Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>, TError = unknown>(
 id: MaybeRef<string>,
    changeDeadlineDto: MaybeRef<ChangeDeadlineDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerChangeDeadlineV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerChangeDeadlineV1QueryOptions(id,changeDeadlineDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerPartialReportV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerPartialReportV1ResponseSuccess = (assignmentsControllerPartialReportV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerPartialReportV1Response = (assignmentsControllerPartialReportV1ResponseSuccess)

export const getAssignmentsControllerPartialReportV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/partial-report`
}

/**
 * @summary Соисполнитель сдаёт частичный отчёт исполнителю: текст и/или файлы
 */
export const assignmentsControllerPartialReportV1 = async (id: string,
    assignmentsControllerPartialReportV1Body: AssignmentsControllerPartialReportV1Body, options?: RequestInit): Promise<assignmentsControllerPartialReportV1Response> => {
    const formData = new FormData();
if(assignmentsControllerPartialReportV1Body.text !== undefined) {
 formData.append(`text`, assignmentsControllerPartialReportV1Body.text);
 }
if(assignmentsControllerPartialReportV1Body.forEmployeeId !== undefined) {
 formData.append(`forEmployeeId`, assignmentsControllerPartialReportV1Body.forEmployeeId);
 }
if(assignmentsControllerPartialReportV1Body.files !== undefined) {
 assignmentsControllerPartialReportV1Body.files.forEach(value => formData.append(`files`, value));
 }

  return apiRequest<assignmentsControllerPartialReportV1Response>(getAssignmentsControllerPartialReportV1Url(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAssignmentsControllerPartialReportV1QueryKey = (id: MaybeRef<string>,
    assignmentsControllerPartialReportV1Body?: MaybeRef<AssignmentsControllerPartialReportV1Body>,) => {
    return [
    'POST', 'api','v1','assignments',id,'partial-report', assignmentsControllerPartialReportV1Body
    ] as const;
    }


export const getAssignmentsControllerPartialReportV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>, TError = unknown>(id: MaybeRef<string>,
    assignmentsControllerPartialReportV1Body: MaybeRef<AssignmentsControllerPartialReportV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerPartialReportV1QueryKey(id,assignmentsControllerPartialReportV1Body);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>> = ({ signal }) => assignmentsControllerPartialReportV1(unref(id),unref(assignmentsControllerPartialReportV1Body), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>, TError, TData>
}

export type AssignmentsControllerPartialReportV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>>
export type AssignmentsControllerPartialReportV1QueryError = unknown


/**
 * @summary Соисполнитель сдаёт частичный отчёт исполнителю: текст и/или файлы
 */

export function useAssignmentsControllerPartialReportV1<TData = Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>, TError = unknown>(
 id: MaybeRef<string>,
    assignmentsControllerPartialReportV1Body: MaybeRef<AssignmentsControllerPartialReportV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerPartialReportV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerPartialReportV1QueryOptions(id,assignmentsControllerPartialReportV1Body,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerAddCoExecutorV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerAddCoExecutorV1ResponseSuccess = (assignmentsControllerAddCoExecutorV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerAddCoExecutorV1Response = (assignmentsControllerAddCoExecutorV1ResponseSuccess)

export const getAssignmentsControllerAddCoExecutorV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/co-executors`
}

/**
 * @summary Добавить соисполнителя (исполнитель или ведущий поручение)
 */
export const assignmentsControllerAddCoExecutorV1 = async (id: string,
    addCoExecutorDto: AddCoExecutorDto, options?: RequestInit): Promise<assignmentsControllerAddCoExecutorV1Response> => {

  return apiRequest<assignmentsControllerAddCoExecutorV1Response>(getAssignmentsControllerAddCoExecutorV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addCoExecutorDto)
  }
);}





export const getAssignmentsControllerAddCoExecutorV1QueryKey = (id: MaybeRef<string>,
    addCoExecutorDto?: MaybeRef<AddCoExecutorDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'co-executors', addCoExecutorDto
    ] as const;
    }


export const getAssignmentsControllerAddCoExecutorV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>, TError = unknown>(id: MaybeRef<string>,
    addCoExecutorDto: MaybeRef<AddCoExecutorDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerAddCoExecutorV1QueryKey(id,addCoExecutorDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>> = ({ signal }) => assignmentsControllerAddCoExecutorV1(unref(id),unref(addCoExecutorDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>, TError, TData>
}

export type AssignmentsControllerAddCoExecutorV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>>
export type AssignmentsControllerAddCoExecutorV1QueryError = unknown


/**
 * @summary Добавить соисполнителя (исполнитель или ведущий поручение)
 */

export function useAssignmentsControllerAddCoExecutorV1<TData = Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>, TError = unknown>(
 id: MaybeRef<string>,
    addCoExecutorDto: MaybeRef<AddCoExecutorDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddCoExecutorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerAddCoExecutorV1QueryOptions(id,addCoExecutorDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerRemoveCoExecutorV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerRemoveCoExecutorV1ResponseSuccess = (assignmentsControllerRemoveCoExecutorV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerRemoveCoExecutorV1Response = (assignmentsControllerRemoveCoExecutorV1ResponseSuccess)

export const getAssignmentsControllerRemoveCoExecutorV1Url = (id: string,
    employeeId: string,) => {




  return `/api/v1/assignments/${id}/co-executors/${employeeId}`
}

/**
 * @summary Убрать соисполнителя (его частичные отчёты остаются)
 */
export const assignmentsControllerRemoveCoExecutorV1 = async (id: string,
    employeeId: string, options?: RequestInit): Promise<assignmentsControllerRemoveCoExecutorV1Response> => {

  return apiRequest<assignmentsControllerRemoveCoExecutorV1Response>(getAssignmentsControllerRemoveCoExecutorV1Url(id,employeeId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAssignmentsControllerRemoveCoExecutorV1QueryKey = (id: MaybeRef<string>,
    employeeId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','assignments',id,'co-executors',employeeId
    ] as const;
    }


export const getAssignmentsControllerRemoveCoExecutorV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>, TError = unknown>(id: MaybeRef<string>,
    employeeId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerRemoveCoExecutorV1QueryKey(id,employeeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>> = ({ signal }) => assignmentsControllerRemoveCoExecutorV1(unref(id),unref(employeeId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(employeeId) !== null && unref(employeeId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>, TError, TData>
}

export type AssignmentsControllerRemoveCoExecutorV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>>
export type AssignmentsControllerRemoveCoExecutorV1QueryError = unknown


/**
 * @summary Убрать соисполнителя (его частичные отчёты остаются)
 */

export function useAssignmentsControllerRemoveCoExecutorV1<TData = Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>, TError = unknown>(
 id: MaybeRef<string>,
    employeeId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveCoExecutorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerRemoveCoExecutorV1QueryOptions(id,employeeId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerDelegationCandidatesV1Response200 = {
  data: AssignmentPersonDto[]
  status: 200
}

export type assignmentsControllerDelegationCandidatesV1ResponseSuccess = (assignmentsControllerDelegationCandidatesV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerDelegationCandidatesV1Response = (assignmentsControllerDelegationCandidatesV1ResponseSuccess)

export const getAssignmentsControllerDelegationCandidatesV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/delegation-candidates`
}

/**
 * @summary Кому можно делегировать: своё подразделение и вложенные
 */
export const assignmentsControllerDelegationCandidatesV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerDelegationCandidatesV1Response> => {

  return apiRequest<assignmentsControllerDelegationCandidatesV1Response>(getAssignmentsControllerDelegationCandidatesV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerDelegationCandidatesV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerDelegationCandidatesV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerDelegationCandidatesV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['assignmentsControllerDelegationCandidatesV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerDelegationCandidatesV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  assignmentsControllerDelegationCandidatesV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerDelegationCandidatesV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerDelegationCandidatesV1>>>

    export type AssignmentsControllerDelegationCandidatesV1MutationError = unknown

    /**
 * @summary Кому можно делегировать: своё подразделение и вложенные
 */
export const useAssignmentsControllerDelegationCandidatesV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerDelegationCandidatesV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerDelegationCandidatesV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAssignmentsControllerDelegationCandidatesV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerDelegateV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerDelegateV1ResponseSuccess = (assignmentsControllerDelegateV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerDelegateV1Response = (assignmentsControllerDelegateV1ResponseSuccess)

export const getAssignmentsControllerDelegateV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/delegate`
}

/**
 * @summary Делегировать часть: создать дочернее поручение
 */
export const assignmentsControllerDelegateV1 = async (id: string,
    delegateAssignmentDto: DelegateAssignmentDto, options?: RequestInit): Promise<assignmentsControllerDelegateV1Response> => {

  return apiRequest<assignmentsControllerDelegateV1Response>(getAssignmentsControllerDelegateV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(delegateAssignmentDto)
  }
);}





export const getAssignmentsControllerDelegateV1QueryKey = (id: MaybeRef<string>,
    delegateAssignmentDto?: MaybeRef<DelegateAssignmentDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'delegate', delegateAssignmentDto
    ] as const;
    }


export const getAssignmentsControllerDelegateV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>, TError = unknown>(id: MaybeRef<string>,
    delegateAssignmentDto: MaybeRef<DelegateAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerDelegateV1QueryKey(id,delegateAssignmentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>> = ({ signal }) => assignmentsControllerDelegateV1(unref(id),unref(delegateAssignmentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>, TError, TData>
}

export type AssignmentsControllerDelegateV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>>
export type AssignmentsControllerDelegateV1QueryError = unknown


/**
 * @summary Делегировать часть: создать дочернее поручение
 */

export function useAssignmentsControllerDelegateV1<TData = Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>, TError = unknown>(
 id: MaybeRef<string>,
    delegateAssignmentDto: MaybeRef<DelegateAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDelegateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerDelegateV1QueryOptions(id,delegateAssignmentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerAddFileV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerAddFileV1ResponseSuccess = (assignmentsControllerAddFileV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerAddFileV1Response = (assignmentsControllerAddFileV1ResponseSuccess)

export const getAssignmentsControllerAddFileV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/files`
}

/**
 * @summary Приложить файл к поручению (до 50 МБ)
 */
export const assignmentsControllerAddFileV1 = async (id: string,
    assignmentsControllerAddFileV1Body: AssignmentsControllerAddFileV1Body, options?: RequestInit): Promise<assignmentsControllerAddFileV1Response> => {
    const formData = new FormData();
formData.append(`file`, assignmentsControllerAddFileV1Body.file);

  return apiRequest<assignmentsControllerAddFileV1Response>(getAssignmentsControllerAddFileV1Url(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAssignmentsControllerAddFileV1QueryKey = (id: MaybeRef<string>,
    assignmentsControllerAddFileV1Body?: MaybeRef<AssignmentsControllerAddFileV1Body>,) => {
    return [
    'POST', 'api','v1','assignments',id,'files', assignmentsControllerAddFileV1Body
    ] as const;
    }


export const getAssignmentsControllerAddFileV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>, TError = unknown>(id: MaybeRef<string>,
    assignmentsControllerAddFileV1Body: MaybeRef<AssignmentsControllerAddFileV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerAddFileV1QueryKey(id,assignmentsControllerAddFileV1Body);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>> = ({ signal }) => assignmentsControllerAddFileV1(unref(id),unref(assignmentsControllerAddFileV1Body), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>, TError, TData>
}

export type AssignmentsControllerAddFileV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>>
export type AssignmentsControllerAddFileV1QueryError = unknown


/**
 * @summary Приложить файл к поручению (до 50 МБ)
 */

export function useAssignmentsControllerAddFileV1<TData = Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>, TError = unknown>(
 id: MaybeRef<string>,
    assignmentsControllerAddFileV1Body: MaybeRef<AssignmentsControllerAddFileV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddFileV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerAddFileV1QueryOptions(id,assignmentsControllerAddFileV1Body,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerRemoveFileV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerRemoveFileV1ResponseSuccess = (assignmentsControllerRemoveFileV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerRemoveFileV1Response = (assignmentsControllerRemoveFileV1ResponseSuccess)

export const getAssignmentsControllerRemoveFileV1Url = (id: string,
    fileId: string,) => {




  return `/api/v1/assignments/${id}/files/${fileId}`
}

/**
 * @summary Удалить вложение поручения (файлы отчётов не удаляются)
 */
export const assignmentsControllerRemoveFileV1 = async (id: string,
    fileId: string, options?: RequestInit): Promise<assignmentsControllerRemoveFileV1Response> => {

  return apiRequest<assignmentsControllerRemoveFileV1Response>(getAssignmentsControllerRemoveFileV1Url(id,fileId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAssignmentsControllerRemoveFileV1QueryKey = (id: MaybeRef<string>,
    fileId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','assignments',id,'files',fileId
    ] as const;
    }


export const getAssignmentsControllerRemoveFileV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>, TError = unknown>(id: MaybeRef<string>,
    fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerRemoveFileV1QueryKey(id,fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>> = ({ signal }) => assignmentsControllerRemoveFileV1(unref(id),unref(fileId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(fileId) !== null && unref(fileId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>, TError, TData>
}

export type AssignmentsControllerRemoveFileV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>>
export type AssignmentsControllerRemoveFileV1QueryError = unknown


/**
 * @summary Удалить вложение поручения (файлы отчётов не удаляются)
 */

export function useAssignmentsControllerRemoveFileV1<TData = Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>, TError = unknown>(
 id: MaybeRef<string>,
    fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveFileV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerRemoveFileV1QueryOptions(id,fileId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerFileUrlV1Response200 = {
  data: AssignmentFileUrlDto
  status: 200
}

export type assignmentsControllerFileUrlV1ResponseSuccess = (assignmentsControllerFileUrlV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerFileUrlV1Response = (assignmentsControllerFileUrlV1ResponseSuccess)

export const getAssignmentsControllerFileUrlV1Url = (id: string,
    fileId: string,
    params?: AssignmentsControllerFileUrlV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assignments/${id}/files/${fileId}/url?${stringifiedParams}` : `/api/v1/assignments/${id}/files/${fileId}/url`
}

/**
 * @summary Временная ссылка на файл; inline=true — для просмотра в браузере (картинки, PDF, txt)
 */
export const assignmentsControllerFileUrlV1 = async (id: string,
    fileId: string,
    params?: AssignmentsControllerFileUrlV1Params, options?: RequestInit): Promise<assignmentsControllerFileUrlV1Response> => {

  return apiRequest<assignmentsControllerFileUrlV1Response>(getAssignmentsControllerFileUrlV1Url(id,fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getAssignmentsControllerFileUrlV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerFileUrlV1>>, TError,{id: string;fileId: string;params?: AssignmentsControllerFileUrlV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerFileUrlV1>>, TError,{id: string;fileId: string;params?: AssignmentsControllerFileUrlV1Params}, TContext> => {

const mutationKey = ['assignmentsControllerFileUrlV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignmentsControllerFileUrlV1>>, {id: string;fileId: string;params?: AssignmentsControllerFileUrlV1Params}> = (props) => {
          const {id,fileId,params} = props ?? {};

          return  assignmentsControllerFileUrlV1(id,fileId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignmentsControllerFileUrlV1MutationResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerFileUrlV1>>>

    export type AssignmentsControllerFileUrlV1MutationError = unknown

    /**
 * @summary Временная ссылка на файл; inline=true — для просмотра в браузере (картинки, PDF, txt)
 */
export const useAssignmentsControllerFileUrlV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignmentsControllerFileUrlV1>>, TError,{id: string;fileId: string;params?: AssignmentsControllerFileUrlV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignmentsControllerFileUrlV1>>,
        TError,
        {id: string;fileId: string;params?: AssignmentsControllerFileUrlV1Params},
        TContext
      > => {
      return useMutation(getAssignmentsControllerFileUrlV1MutationOptions(options), queryClient);
    }
    export type assignmentsControllerAcceptV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerAcceptV1ResponseSuccess = (assignmentsControllerAcceptV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerAcceptV1Response = (assignmentsControllerAcceptV1ResponseSuccess)

export const getAssignmentsControllerAcceptV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/accept`
}

/**
 * @summary Принять отчёт на своём этапе
 */
export const assignmentsControllerAcceptV1 = async (id: string, options?: RequestInit): Promise<assignmentsControllerAcceptV1Response> => {

  return apiRequest<assignmentsControllerAcceptV1Response>(getAssignmentsControllerAcceptV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAssignmentsControllerAcceptV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'POST', 'api','v1','assignments',id,'accept'
    ] as const;
    }


export const getAssignmentsControllerAcceptV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerAcceptV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>> = ({ signal }) => assignmentsControllerAcceptV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>, TError, TData>
}

export type AssignmentsControllerAcceptV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>>
export type AssignmentsControllerAcceptV1QueryError = unknown


/**
 * @summary Принять отчёт на своём этапе
 */

export function useAssignmentsControllerAcceptV1<TData = Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAcceptV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerAcceptV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerReturnForReworkV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerReturnForReworkV1ResponseSuccess = (assignmentsControllerReturnForReworkV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerReturnForReworkV1Response = (assignmentsControllerReturnForReworkV1ResponseSuccess)

export const getAssignmentsControllerReturnForReworkV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/return`
}

/**
 * @summary Вернуть отчёт на доработку (замечания обязательны)
 */
export const assignmentsControllerReturnForReworkV1 = async (id: string,
    returnReportDto: ReturnReportDto, options?: RequestInit): Promise<assignmentsControllerReturnForReworkV1Response> => {

  return apiRequest<assignmentsControllerReturnForReworkV1Response>(getAssignmentsControllerReturnForReworkV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnReportDto)
  }
);}





export const getAssignmentsControllerReturnForReworkV1QueryKey = (id: MaybeRef<string>,
    returnReportDto?: MaybeRef<ReturnReportDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'return', returnReportDto
    ] as const;
    }


export const getAssignmentsControllerReturnForReworkV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>, TError = unknown>(id: MaybeRef<string>,
    returnReportDto: MaybeRef<ReturnReportDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerReturnForReworkV1QueryKey(id,returnReportDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>> = ({ signal }) => assignmentsControllerReturnForReworkV1(unref(id),unref(returnReportDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>, TError, TData>
}

export type AssignmentsControllerReturnForReworkV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>>
export type AssignmentsControllerReturnForReworkV1QueryError = unknown


/**
 * @summary Вернуть отчёт на доработку (замечания обязательны)
 */

export function useAssignmentsControllerReturnForReworkV1<TData = Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>, TError = unknown>(
 id: MaybeRef<string>,
    returnReportDto: MaybeRef<ReturnReportDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerReturnForReworkV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerReturnForReworkV1QueryOptions(id,returnReportDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerCancelV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerCancelV1ResponseSuccess = (assignmentsControllerCancelV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerCancelV1Response = (assignmentsControllerCancelV1ResponseSuccess)

export const getAssignmentsControllerCancelV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/cancel`
}

/**
 * @summary Аннулировать (причина обязательна)
 */
export const assignmentsControllerCancelV1 = async (id: string,
    cancelAssignmentDto: CancelAssignmentDto, options?: RequestInit): Promise<assignmentsControllerCancelV1Response> => {

  return apiRequest<assignmentsControllerCancelV1Response>(getAssignmentsControllerCancelV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelAssignmentDto)
  }
);}





export const getAssignmentsControllerCancelV1QueryKey = (id: MaybeRef<string>,
    cancelAssignmentDto?: MaybeRef<CancelAssignmentDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'cancel', cancelAssignmentDto
    ] as const;
    }


export const getAssignmentsControllerCancelV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerCancelV1>>, TError = unknown>(id: MaybeRef<string>,
    cancelAssignmentDto: MaybeRef<CancelAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCancelV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerCancelV1QueryKey(id,cancelAssignmentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerCancelV1>>> = ({ signal }) => assignmentsControllerCancelV1(unref(id),unref(cancelAssignmentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCancelV1>>, TError, TData>
}

export type AssignmentsControllerCancelV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerCancelV1>>>
export type AssignmentsControllerCancelV1QueryError = unknown


/**
 * @summary Аннулировать (причина обязательна)
 */

export function useAssignmentsControllerCancelV1<TData = Awaited<ReturnType<typeof assignmentsControllerCancelV1>>, TError = unknown>(
 id: MaybeRef<string>,
    cancelAssignmentDto: MaybeRef<CancelAssignmentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCancelV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerCancelV1QueryOptions(id,cancelAssignmentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerAddLinkV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerAddLinkV1ResponseSuccess = (assignmentsControllerAddLinkV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerAddLinkV1Response = (assignmentsControllerAddLinkV1ResponseSuccess)

export const getAssignmentsControllerAddLinkV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/links`
}

/**
 * @summary Связать с другим поручением по номеру («связано с поручением №…»)
 */
export const assignmentsControllerAddLinkV1 = async (id: string,
    addLinkDto: AddLinkDto, options?: RequestInit): Promise<assignmentsControllerAddLinkV1Response> => {

  return apiRequest<assignmentsControllerAddLinkV1Response>(getAssignmentsControllerAddLinkV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addLinkDto)
  }
);}





export const getAssignmentsControllerAddLinkV1QueryKey = (id: MaybeRef<string>,
    addLinkDto?: MaybeRef<AddLinkDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'links', addLinkDto
    ] as const;
    }


export const getAssignmentsControllerAddLinkV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>, TError = unknown>(id: MaybeRef<string>,
    addLinkDto: MaybeRef<AddLinkDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerAddLinkV1QueryKey(id,addLinkDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>> = ({ signal }) => assignmentsControllerAddLinkV1(unref(id),unref(addLinkDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>, TError, TData>
}

export type AssignmentsControllerAddLinkV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>>
export type AssignmentsControllerAddLinkV1QueryError = unknown


/**
 * @summary Связать с другим поручением по номеру («связано с поручением №…»)
 */

export function useAssignmentsControllerAddLinkV1<TData = Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>, TError = unknown>(
 id: MaybeRef<string>,
    addLinkDto: MaybeRef<AddLinkDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerAddLinkV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerAddLinkV1QueryOptions(id,addLinkDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerRemoveLinkV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerRemoveLinkV1ResponseSuccess = (assignmentsControllerRemoveLinkV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerRemoveLinkV1Response = (assignmentsControllerRemoveLinkV1ResponseSuccess)

export const getAssignmentsControllerRemoveLinkV1Url = (id: string,
    linkId: string,) => {




  return `/api/v1/assignments/${id}/links/${linkId}`
}

/**
 * @summary Убрать связь с поручением
 */
export const assignmentsControllerRemoveLinkV1 = async (id: string,
    linkId: string, options?: RequestInit): Promise<assignmentsControllerRemoveLinkV1Response> => {

  return apiRequest<assignmentsControllerRemoveLinkV1Response>(getAssignmentsControllerRemoveLinkV1Url(id,linkId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAssignmentsControllerRemoveLinkV1QueryKey = (id: MaybeRef<string>,
    linkId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','assignments',id,'links',linkId
    ] as const;
    }


export const getAssignmentsControllerRemoveLinkV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>, TError = unknown>(id: MaybeRef<string>,
    linkId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerRemoveLinkV1QueryKey(id,linkId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>> = ({ signal }) => assignmentsControllerRemoveLinkV1(unref(id),unref(linkId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(linkId) !== null && unref(linkId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>, TError, TData>
}

export type AssignmentsControllerRemoveLinkV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>>
export type AssignmentsControllerRemoveLinkV1QueryError = unknown


/**
 * @summary Убрать связь с поручением
 */

export function useAssignmentsControllerRemoveLinkV1<TData = Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>, TError = unknown>(
 id: MaybeRef<string>,
    linkId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerRemoveLinkV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerRemoveLinkV1QueryOptions(id,linkId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerEditCommentV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerEditCommentV1ResponseSuccess = (assignmentsControllerEditCommentV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerEditCommentV1Response = (assignmentsControllerEditCommentV1ResponseSuccess)

export const getAssignmentsControllerEditCommentV1Url = (id: string,
    commentId: string,) => {




  return `/api/v1/assignments/${id}/comments/${commentId}`
}

/**
 * @summary Поправить свой комментарий
 */
export const assignmentsControllerEditCommentV1 = async (id: string,
    commentId: string,
    createCommentDto: CreateCommentDto, options?: RequestInit): Promise<assignmentsControllerEditCommentV1Response> => {

  return apiRequest<assignmentsControllerEditCommentV1Response>(getAssignmentsControllerEditCommentV1Url(id,commentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCommentDto)
  }
);}





export const getAssignmentsControllerEditCommentV1QueryKey = (id: MaybeRef<string>,
    commentId: MaybeRef<string>,
    createCommentDto?: MaybeRef<CreateCommentDto>,) => {
    return [
    'PATCH', 'api','v1','assignments',id,'comments',commentId, createCommentDto
    ] as const;
    }


export const getAssignmentsControllerEditCommentV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>, TError = unknown>(id: MaybeRef<string>,
    commentId: MaybeRef<string>,
    createCommentDto: MaybeRef<CreateCommentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerEditCommentV1QueryKey(id,commentId,createCommentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>> = ({ signal }) => assignmentsControllerEditCommentV1(unref(id),unref(commentId),unref(createCommentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(commentId) !== null && unref(commentId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>, TError, TData>
}

export type AssignmentsControllerEditCommentV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>>
export type AssignmentsControllerEditCommentV1QueryError = unknown


/**
 * @summary Поправить свой комментарий
 */

export function useAssignmentsControllerEditCommentV1<TData = Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>, TError = unknown>(
 id: MaybeRef<string>,
    commentId: MaybeRef<string>,
    createCommentDto: MaybeRef<CreateCommentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerEditCommentV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerEditCommentV1QueryOptions(id,commentId,createCommentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerDeleteCommentV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerDeleteCommentV1ResponseSuccess = (assignmentsControllerDeleteCommentV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerDeleteCommentV1Response = (assignmentsControllerDeleteCommentV1ResponseSuccess)

export const getAssignmentsControllerDeleteCommentV1Url = (id: string,
    commentId: string,) => {




  return `/api/v1/assignments/${id}/comments/${commentId}`
}

/**
 * @summary Удалить свой комментарий (в ленте останется «Комментарий удалён»)
 */
export const assignmentsControllerDeleteCommentV1 = async (id: string,
    commentId: string, options?: RequestInit): Promise<assignmentsControllerDeleteCommentV1Response> => {

  return apiRequest<assignmentsControllerDeleteCommentV1Response>(getAssignmentsControllerDeleteCommentV1Url(id,commentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAssignmentsControllerDeleteCommentV1QueryKey = (id: MaybeRef<string>,
    commentId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','assignments',id,'comments',commentId
    ] as const;
    }


export const getAssignmentsControllerDeleteCommentV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>, TError = unknown>(id: MaybeRef<string>,
    commentId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerDeleteCommentV1QueryKey(id,commentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>> = ({ signal }) => assignmentsControllerDeleteCommentV1(unref(id),unref(commentId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(commentId) !== null && unref(commentId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>, TError, TData>
}

export type AssignmentsControllerDeleteCommentV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>>
export type AssignmentsControllerDeleteCommentV1QueryError = unknown


/**
 * @summary Удалить свой комментарий (в ленте останется «Комментарий удалён»)
 */

export function useAssignmentsControllerDeleteCommentV1<TData = Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>, TError = unknown>(
 id: MaybeRef<string>,
    commentId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerDeleteCommentV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerDeleteCommentV1QueryOptions(id,commentId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type assignmentsControllerCommentV1Response200 = {
  data: AssignmentDetailDto
  status: 200
}

export type assignmentsControllerCommentV1ResponseSuccess = (assignmentsControllerCommentV1Response200) & {
  headers: Headers;
};
;

export type assignmentsControllerCommentV1Response = (assignmentsControllerCommentV1ResponseSuccess)

export const getAssignmentsControllerCommentV1Url = (id: string,) => {




  return `/api/v1/assignments/${id}/comments`
}

/**
 * @summary Добавить комментарий
 */
export const assignmentsControllerCommentV1 = async (id: string,
    createCommentDto: CreateCommentDto, options?: RequestInit): Promise<assignmentsControllerCommentV1Response> => {

  return apiRequest<assignmentsControllerCommentV1Response>(getAssignmentsControllerCommentV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCommentDto)
  }
);}





export const getAssignmentsControllerCommentV1QueryKey = (id: MaybeRef<string>,
    createCommentDto?: MaybeRef<CreateCommentDto>,) => {
    return [
    'POST', 'api','v1','assignments',id,'comments', createCommentDto
    ] as const;
    }


export const getAssignmentsControllerCommentV1QueryOptions = <TData = Awaited<ReturnType<typeof assignmentsControllerCommentV1>>, TError = unknown>(id: MaybeRef<string>,
    createCommentDto: MaybeRef<CreateCommentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCommentV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAssignmentsControllerCommentV1QueryKey(id,createCommentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assignmentsControllerCommentV1>>> = ({ signal }) => assignmentsControllerCommentV1(unref(id),unref(createCommentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCommentV1>>, TError, TData>
}

export type AssignmentsControllerCommentV1QueryResult = NonNullable<Awaited<ReturnType<typeof assignmentsControllerCommentV1>>>
export type AssignmentsControllerCommentV1QueryError = unknown


/**
 * @summary Добавить комментарий
 */

export function useAssignmentsControllerCommentV1<TData = Awaited<ReturnType<typeof assignmentsControllerCommentV1>>, TError = unknown>(
 id: MaybeRef<string>,
    createCommentDto: MaybeRef<CreateCommentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assignmentsControllerCommentV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssignmentsControllerCommentV1QueryOptions(id,createCommentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






